import { Component } from 'san';
import * as echarts from 'echarts';
import * as _ from 'lodash';
import { ELight } from 'src/enums';

export default class DashboardDoughnut extends Component {
    myChart: echarts.ECharts;
    constructor(options: any) {
        super(options);
    }

    attached() {
        this.initChart();
        // 监听，若widget大小发生变化，chart resize
        const elem = document.getElementById(`chart-${this.data.get('type')}`);
        const resizeObserver = new ResizeObserver(() => {
            this.myChart.resize();
        });
        resizeObserver.observe(elem);
    }

    initData(): {
        series: [];
    } {
        return {
            series: [],
        };
    }

    initChart() {
        this.initItems();
        this.initSeries();
        const type = this.data.get('type');
        const items = this.data.get('items');
        const hasData = items[0].value || items[1].value || items[2].value;
        const chartDom = document.getElementById(`chart-${type}`);
        if (chartDom) {
            echarts.dispose(document.getElementById(`chart-${type}`));
        }
        this.myChart = echarts.init(chartDom);
        const option = {
            tooltip:{},
            legend: {
                orient: 'vertical',
                top: '16',
                right: '16',
            },
            title: {
                text: type,
                left: '16',
                top: '4',
                textStyle: {
                    color: '#1A1A1A',
                    fontWeight: 'normal',
                    fontSize: '14',
                }
            },
            xAxis: { 
                show: hasData,
                type: 'category',
                data:[] 
            },
            yAxis: {
                name: '单位（个）',
                show: hasData,
                type: 'value',
                minInterval:1
            },
            graphic: {
                type: 'text',
                left: 'center',
                top: 'center',
                style:{
                    text: !hasData ? "暂无超期、延期、到期项目" : "",
                    textAlign:"center",
                    fill:"#c0c0c0",
                    fontSize: 16
                }
            },
            series: this.data.get('series'),
            grid: {
                top: '40%',
                bottom: '4%',
                left: '18%',
                right: '18%',
            },
            color: ['#ED1D0C', '#F09000', '#0086FB']
          };

        option && this.myChart.setOption(option);
    }

    initItems() {
        const oldItems = this.data.get('items');
        const items = [];
        _.forEach(oldItems, (item) => {
            items.push({
                name: ELight.Red == item.key ? '超期' : ELight.Yellow == item.key ? '延期' : '到期',
                value: item.value,
            });
        });
        this.data.set('items', _.reverse(items));
    }

    initSeries() {
        const items = this.data.get('items');
        const series = [];
        _.forEach(items, (item) => {
            series.push({
                name: item.name,
                type: 'bar',
                barWidth: 35, 
                barGap: '50%',
                data: [item.value],
                label: {
                    show: true,
                    position: 'top',
                    formatter(val: any) { // 数值为0时不展示
                        if (val.value !== 0) {
                            return val.value;
                        } else {
                            return '';
                        }
                    },
                }
            })
        });
        this.data.set('series', series);
    }
}
